import src from "IMAGE";
export default { src, width: 751, height: 207, blurWidth: 0, blurHeight: 0};
